/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FleetAuthenticateType {
    LOGIN = 'login',
    LOGOUT = 'logout'
}


export function instanceOfFleetAuthenticateType(value: any): boolean {
    for (const key in FleetAuthenticateType) {
        if (Object.prototype.hasOwnProperty.call(FleetAuthenticateType, key)) {
            if (FleetAuthenticateType[key as keyof typeof FleetAuthenticateType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FleetAuthenticateTypeFromJSON(json: any): FleetAuthenticateType {
    return FleetAuthenticateTypeFromJSONTyped(json, false);
}

export function FleetAuthenticateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetAuthenticateType {
    return json as FleetAuthenticateType;
}

export function FleetAuthenticateTypeToJSON(value?: FleetAuthenticateType | null): any {
    return value as any;
}

export function FleetAuthenticateTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FleetAuthenticateType {
    return value as FleetAuthenticateType;
}

